import type { ClassNameProp } from '@library/types'
import cn from 'classnames'
import type { FC, PropsWithChildren } from 'react'

import css from './FooterBodyBlock.css'

export const FooterBodyBlock: FC<PropsWithChildren<ClassNameProp>> = ({ children, className }) => {
  return <section className={cn(css.container, className)}>{children}</section>
}
